export default {
  install: function (Vue) {
    Vue.prototype.$computedImageCount = timeImageList => {
      if (!timeImageList || !timeImageList.length) return 0;
      return timeImageList.filter(one => one.url).length;
    };
    Vue.prototype.$showField = (rentType, field, condition) => {
      let result = showFieldWithRentType[field].rentType.includes(rentType);
      let conditionResult = true;
      if (condition != null) {
        conditionResult = condition();
      }
      return result && conditionResult;
    };
  },
};

const showFieldWithRentType = {
  guarantor: {
    //担保人
    rentType: [0, 1, 2, 3, 4, 10],
  },
  guarantorBigData: {
    //担保人大数据
    // rentType: [2, 3],
    rentType: [0, 1, 2, 3, 10],
  },
  times11_7: {
    //担保人的案底证明
    rentType: [0, 1, 2, 3, 10],
  },
  times11_8: {
    //担保人的征信报告
    rentType: [1, 2, 3, 10],
  },
  times11_9: {
    //担保人的驾照/12123
    rentType: [0, 1, 4, 10],
  },
  times11_12: {
    //担保人驾照承诺函
    rentType: [0, 1, 4, 10],
  },
  hadIncreaseAmountInformation: {
    //是否有提额资料
    rentType: [1, 10,138],
  },
  permanentResidentType: {
    //常住资料
    rentType: [3,128],
  },
  financialProofType: {
    //财力证明
    rentType: [3,128],
  },
  financialDataType: {
    rentType: [2],
  },
  times2_14: {
    //人法失信截图
    rentType: [0, 1, 2, 3, 4, 10,128,138],
  },
  times2_17: {
    //违章记录
    rentType: [1, 3, 10,128,138],
  },
  times2_18: {
    //年检截图
    rentType: [1, 3, 10,128,138],
  },
  times2_50: {
    //面审表
    rentType: [],
  },
  // 本人银行卡
  times2_5: {
    rentType: [0, 1, 3, 4, 10,128,138],
  },
  times2_2: {
    //客户征信
    rentType: [1, 2, 3, 10,128,138],
  },
  lessee: {
    rentType: [0, 1, 3, 4, 10,128,138],
  },
  carDealer: {
    rentType: [2],
  },
  // times11_7: {
  //   // rentType: [3],
  //   rentType: [0, 1, 2, 3, 10,128,138],
  // },
  times3_7: {
    rentType: [2],
  },
  times5_31: {
    rentType: [1, 3, 10,128,138],
  },
  times4_2: {
    rentType: [0, 2],
  },
  times4_1: {
    rentType: [0, 2, 4],
  },
  times4_3: {
    rentType: [1, 3, 10,128,138],
  },
  times4_20: {
    rentType: [0, 2, 4],
  },
  times4_21: {
    rentType: [0, 2, 4],
  },
  times4_22: {
    rentType: [0, 2, 4],
  },
  times5_1: {
    rentType: [1, 3, 10,128,138],
  },
  times5_10: {
    rentType: [0, 1, 2, 3, 10,128,138],
  },
  times34_1: {
    rentType: [0, 1, 2, 3, 10,128,138],
  },
  carNewFirstNumber: {
    rentType: [2],
  },
};
